export default {
    state: {
        isCollapse: false,
        tabsList: JSON.parse(localStorage.getItem("userOpenGctMarkingMenu")) ?? [],
        currentMenu: JSON.parse(localStorage.getItem("userGctMarkingCurrentMenu")) ?? null,
    },
    mutations: {
        collapseMenu(state) {
            state.isCollapse = !state.isCollapse
        },
        selectMenu(state, val) {
            const result = state.tabsList.findIndex(item => item.componentName === val.componentName)
            if (val.componentName !== 'Home') {
                state.currentMenu = val
                if (result === -1) {
                    state.tabsList.push(val)
                }
            } else if (result === -1) {
                state.currentMenu = val;
                state.tabsList.push(val);
            }
            localStorage.setItem("userGctMarkingCurrentMenu", JSON.stringify(val));
            localStorage.setItem("userOpenGctMarkingMenu", JSON.stringify(state.tabsList));
        },
        closeTag(state, val) {
            const result = state.tabsList.findIndex(item => item.componentName === val.componentName)
            state.tabsList.splice(result, 1)
            localStorage.setItem("userOpenGctMarkingMenu", JSON.stringify(state.tabsList));
        }
    }
}